import { Outlet } from 'react-router-dom';
import '@workspace/design-system/globals.css';
import { ModalProvider } from '@workspace/design-system/src/components';

function DesignSystemLayout() {
    return (
        <ModalProvider>
            <Outlet />
        </ModalProvider>
    );
}

export default DesignSystemLayout;


